export default __webpack_public_path__ + "static/media/sameday-icon.d5f2ca4c.svg";